import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import {WebsiteReviewVoteContainerModel} from '../../../../../../models';



@Injectable({providedIn: 'root'})

export class WebsiteReviewVotePublicService extends BaseApiTemplateService<WebsiteReviewVoteContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-review-vote-hdrs/public';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-review-vote-hdrs/public';
    this.httpClient = http;
  }
}
